// extracted by mini-css-extract-plugin
module.exports = {"main":"LandingLayout_main__0Pd5Q","mainSections":"LandingLayout_mainSections__70kFw","russianView":"LandingLayout_russianView__a87ig"};